<template>
<div>
  <div class="row">
    <div class="col-md-6">
      <div class="dash-inner-box">
        <div class="dashboard-heading mb-0">
          <h1>Placement Highlights</h1>
        </div>
        <form class="" id="placementHighlights">
        <div class="info-table">
          <ul>
            <li>
              <div class="row rowFlex">
                <div class="col-md-6 border-right">
                  No. of Companies visited
                </div>
                <div class="col-md-6">
                  <input type="text" id="highlightCompany" name="companies_visited" class="info-input saveField"
                         v-bind:value="`${placementHighlight ? placementHighlight.companies_visited : ''}`"/>
                </div>
              </div>
            </li>
            <li>
              <div class="row rowFlex">
                <div class="col-md-6 border-right">
                  Top Recruiters
                </div>
                <div class="col-md-6">
                  <input type="text" id="highlightRecruiter" name="top_recruiter" class="info-input saveField"
                         v-bind:value="`${placementHighlight ? placementHighlight.top_recruiter : ''}`"/>
                </div>
              </div>
            </li>
            <li>
              <div class="row rowFlex">
                <div class="col-md-6 border-right">
                  No. of Companies Offering Dream Packages
                </div>
                <div class="col-md-6">
                  <input type="text" id="hightlightDream" name="dream_packages" class="info-input saveField"
                         v-bind:value="`${placementHighlight ? placementHighlight.companies_offering_dream_packages : ''}`"/>
                </div>
              </div>
            </li>
            <li>
              <div class="row rowFlex">
                <div class="col-md-6 border-right">
                  Highest Stipend Offered
                </div>
                <div class="col-md-6">
                  <input type="text" id="highlightStipend" name="highest_stipend_offered" class="info-input saveField"
                         v-bind:value="`${placementHighlight ? placementHighlight.highest_stipend_offered : ''}`"/>
                </div>
              </div>
            </li>
            <li>
              <div class="row rowFlex">
                <div class="col-md-6 border-right">
                  Highest placement package
                </div>
                <div class="col-md-6">
                  <input type="text" id="highlightPackage" name="highest_placement_package" class="info-input saveField"
                         v-bind:value="`${placementHighlight ? placementHighlight.highest_placement_package : ''}`"/>
                </div>
              </div>
            </li>
            <li class="text-center">
              <button type="button" class="cpe-button" v-if="$parent.notchLoading === 'placementHighlights'">
                <i class="fas fa-circle-notch fa-spin fa-fw"></i>
              </button>
              <button class="cpe-button" type="button" v-else @click="savePlacementHighlights()">
                {{placementHighlight ? 'Update' : 'Add'}}
              </button>
            </li>
          </ul>
        </div>
      </form>
      </div>
    </div>
    <div class="col-md-6">
      <div class="dash-inner-box">
        <div class="dashboard-heading mb-0">
          <h1>Recruitment By Course</h1>
        </div>
        <form id="coursePlacement">
        <div class="info-table">
          <ul>
            <li>
              <div class="row rowFlex">
                <div class="col-md-4 border-right">
                  Select Course
                </div>
                <div class="col-md-8">
                  <select name="assigned_course_enc_id" class="info-input saveField"
                          v-bind:value="`${updateCoursePlacement ? updateCoursePlacement.assigned_course_enc_id : ''}`">
                    <option value="">Select Course</option>
                    <option v-for="c in $parent.addmissionCourses" v-bind:value="c.assigned_college_enc_id">{{c.course_name}}</option>
                  </select>
                </div>
              </div>
            </li>
            <li>
              <div class="row rowFlex">
                <div class="col-md-4 border-right">
                  Average Package
                </div>
                <div class="col-md-8">
                  <input type="text" name="average_package" class="info-input saveField"
                     @blur="$parent.validateFiled($event)" data-id="reqAlso" data-type="floatNum"
                     v-bind:value="`${updateCoursePlacement ? updateCoursePlacement.average_package : ''}`"/>
                  <p class="errorMsg"></p>
                </div>
              </div>
            </li>
            <li>
              <div class="row rowFlex">
                <div class="col-md-4 border-right">
                  Highest Package
                </div>
                <div class="col-md-8">
                  <input type="text" name="highest_package" class="info-input saveField"
                     @blur="$parent.validateFiled($event)" data-id="reqAlso" data-type="floatNum"
                     v-bind:value="`${updateCoursePlacement ? updateCoursePlacement.highest_package : ''}`"/>
                  <p class="errorMsg"></p>
                </div>
              </div>
            </li>
            <li>
              <div class="row rowFlex">
                <div class="col-md-4 border-right">
                  Companies Visiting
                </div>
                <div class="col-md-8">
                  <input type="text" name="companies_visiting" class="info-input saveField"
                   @blur="$parent.validateFiled($event)" data-id="reqAlso" data-type="number"
                   v-bind:value="`${updateCoursePlacement ? updateCoursePlacement.companies_visiting : ''}`"/>
                  <p class="errorMsg"></p>
                </div>
              </div>
            </li>
            <li>
              <div class="row rowFlex">
                <div class="col-md-4 border-right">
                  Total Offers
                </div>
                <div class="col-md-8">
                  <input type="text" name="total_offers" class="info-input saveField"
                   @blur="$parent.validateFiled($event)" data-id="reqAlso" data-type="number"
                   v-bind:value="`${updateCoursePlacement ? updateCoursePlacement.total_offers : ''}`"/>
                  <p class="errorMsg"></p>
                </div>
              </div>
            </li>
            <li>
              <div class="row rowFlex">
                <div class="col-md-4 border-right">
                  No. of Students Placed
                </div>
                <div class="col-md-8">
                  <input type="text" name="students_placed" class="info-input saveField"
                     @blur="$parent.validateFiled($event)" data-id="reqAlso" data-type="number"
                     v-bind:value="`${updateCoursePlacement ? updateCoursePlacement.students_placed : ''}`"/>
                  <p class="errorMsg"></p>
                </div>
              </div>
            </li>
            <li class="text-center">
              <button type="button" class="cpe-button" v-if="$parent.notchLoading === 'coursePlacement'">
                <i class="fas fa-circle-notch fa-spin fa-fw"></i>
              </button>
              <button type="button" class="cpe-button" v-else-if="updateCoursePlacement"
                v-bind:data-id="updateCoursePlacement.college_recruitment_by_course_enc_id" @click="updateCoursePlacementStats()">
                Update
              </button>
              <button type="button" class="cpe-button" @click="addCoursePlacement()" v-else>Add</button>
            </li>
          </ul>
        </div>
      </form>
      </div>
    </div>
  </div>
  <div class="row mb-20">
    <div class="col-md-12">
      <table class="courseTable">
        <thead>
        <tr>
          <th class="pt-course">Course</th>
          <th class="pt-average">Average Package</th>
          <th class="pt-high">Highest Package</th>
          <th class="pt-company">Companies Visiting</th>
          <th class="pt-offers">Total Offers</th>
          <th class="pt-Placed">Students Placed</th>
          <th class="pt-edit">Edit / Delete</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="cp in coursePlacements">
          <td>{{cp.course_name}}</td>
          <td class="text-center">{{cp.average_package}}</td>
          <td class="text-center">{{cp.highest_package}}</td>
          <td class="text-center">{{cp.companies_visiting}}</td>
          <td class="text-center">{{cp.total_offers}}</td>
          <td class="text-center">{{cp.students_placed}}</td>
          <td class="text-center">
            <button class="editCourse editBtn" v-bind:data-id="cp.assigned_course_enc_id" @click="filterCoursePlacement()">
              <i class="fas fa-pencil-alt"></i>
            </button>
            <button class="editCourse deleteBtn mr10" v-bind:data-id="cp.college_recruitment_by_course_enc_id"
                    @click="removeCoursePlacement()">
              <i class="fas fa-trash-alt"></i>
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div>
  <!--          <div class="row">-->
  <!--            <div class="col-md-12">-->
  <!--              <h3>Top Recruiters</h3>-->
  <!--              <form>-->
  <!--                <div class="info-table">-->
  <!--                  <ul>-->
  <!--                    <li>-->
  <!--                      <div class="row rowFlex mtb15">-->
  <!--                        <div class="col-md-3 border-right">-->
  <!--                          Logo-->
  <!--                        </div>-->
  <!--                        <div class="col-md-3 border-right">-->
  <!--                          Recruiter-->
  <!--                        </div>-->
  <!--                        <div class="col-md-3 border-right">-->
  <!--                          No. Of Recruitments-->
  <!--                        </div>-->
  <!--                        <div class="col-md-3 text-center">-->
  <!--                          Salary Package Offered-->
  <!--                        </div>-->
  <!--                      </div>-->
  <!--                    </li>-->
  <!--                    <li>-->
  <!--                      <div class="row">-->
  <!--                        <div class="col-md-12 text-center">-->
  <!--                          2016-2017-->
  <!--                        </div>-->
  <!--                      </div>-->
  <!--                    </li>-->
  <!--                    <li>-->
  <!--                      <div class="row rowFlex mtb15">-->
  <!--                        <div class="col-md-3 border-right">-->
  <!--                          <div class="topRecLogo">-->
  <!--                                                        <span class="logoshow">-->
  <!--                                                            <p>Add <br>Logo</p>-->
  <!--                                                         </span>-->
  <!--                            <input type="file" id="uploadRacLogo2017" class="uploadCollegeImg uploadImgs facultyImg"-->
  <!--                                   @change="changeRacLogo($event)"/>-->
  <!--                            <label for="uploadRacLogo2017">-->
  <!--                              <div class="editIcon">-->
  <!--                                <i class="fas fa-pencil-alt"></i>-->
  <!--                              </div>-->
  <!--                            </label>-->
  <!--                          </div>-->
  <!--                        </div>-->
  <!--                        <div class="col-md-3 border-right">-->
  <!--                          <input type="text" id="TopRecTwo" name="" placeholder="Recruiter" class="info-input"/>-->
  <!--                        </div>-->
  <!--                        <div class="col-md-3 border-right">-->
  <!--                          <input type="text" id="placementsTwo" name="" placeholder="No. Of Recruitments"-->
  <!--                                 class="info-input"/>-->
  <!--                        </div>-->
  <!--                        <div class="col-md-3">-->
  <!--                          <input type="text" id="packageTwo" name="" placeholder="Package Offered" class="info-input"/>-->
  <!--                        </div>-->
  <!--                      </div>-->
  <!--                      <div class="row">-->
  <!--                        <div class="col-md-12 text-center">-->
  <!--                          <button type="button" class="addMoretr" @click="addMoreRec($event)"><i-->
  <!--                              class="fas fa-plus-circle"></i> Add More-->
  <!--                          </button>-->
  <!--                        </div>-->
  <!--                      </div>-->
  <!--                    </li>-->
  <!--                    <li>-->
  <!--                      <div class="row">-->
  <!--                        <div class="col-md-12 text-center">-->
  <!--                          2017 - 2018-->
  <!--                        </div>-->
  <!--                      </div>-->
  <!--                    </li>-->
  <!--                    <li>-->
  <!--                      <div class="row rowFlex mtb15">-->
  <!--                        <div class="col-md-3 border-right">-->
  <!--                          <div class="topRecLogo">-->
  <!--                                                        <span class="logoshow">-->
  <!--                                                            <p>Add <br>Logo</p>-->
  <!--                                                         </span>-->
  <!--                            <input type="file" id="uploadRacLogo2018" class="uploadCollegeImg uploadImgs facultyImg"-->
  <!--                                   @change="changeRacLogo($event)"/>-->
  <!--                            <label for="uploadRacLogo2018">-->
  <!--                              <div class="editIcon">-->
  <!--                                <i class="fas fa-pencil-alt"></i>-->
  <!--                              </div>-->
  <!--                            </label>-->
  <!--                          </div>-->
  <!--                        </div>-->
  <!--                        <div class="col-md-3 border-right">-->
  <!--                          <input type="text" id="TopRecThree" name="" placeholder="Recruiter" class="info-input"/>-->
  <!--                        </div>-->
  <!--                        <div class="col-md-3 border-right">-->
  <!--                          <input type="text" id="placementsThree" name="" placeholder="No. Of Recruitments"-->
  <!--                                 class="info-input"/>-->
  <!--                        </div>-->
  <!--                        <div class="col-md-3">-->
  <!--                          <input type="text" id="packageThree" name="" placeholder="Package Offered"-->
  <!--                                 class="info-input"/>-->
  <!--                        </div>-->
  <!--                      </div>-->
  <!--                      <div class="row">-->
  <!--                        <div class="col-md-12 text-center">-->
  <!--                          <button type="button" class="addMoretr" @click="addMoreRec($event)"><i-->
  <!--                              class="fas fa-plus-circle"></i> Add More-->
  <!--                          </button>-->
  <!--                        </div>-->
  <!--                      </div>-->
  <!--                    </li>-->
  <!--                    <li>-->
  <!--                      <div class="row">-->
  <!--                        <div class="col-md-12 text-center">-->
  <!--                          2018 - 2019-->
  <!--                        </div>-->
  <!--                      </div>-->
  <!--                    </li>-->
  <!--                    <li>-->
  <!--                      <div class="row rowFlex mtb15">-->
  <!--                        <div class="col-md-3 border-right">-->
  <!--                          <div class="topRecLogo">-->
  <!--                                                        <span class="logoshow">-->
  <!--                                                            <p>Add <br>Logo</p>-->
  <!--                                                         </span>-->
  <!--                            <input type="file" id="uploadRacLogo2019" class="uploadCollegeImg uploadImgs facultyImg"-->
  <!--                                   @change="changeRacLogo($event)"/>-->
  <!--                            <label for="uploadRacLogo2019">-->
  <!--                              <div class="editIcon">-->
  <!--                                <i class="fas fa-pencil-alt"></i>-->
  <!--                              </div>-->
  <!--                            </label>-->
  <!--                          </div>-->
  <!--                        </div>-->
  <!--                        <div class="col-md-3 border-right">-->
  <!--                          <input type="text" id="TopRecFour" name="" placeholder="Recruiter" class="info-input"/>-->
  <!--                        </div>-->
  <!--                        <div class="col-md-3 border-right">-->
  <!--                          <input type="text" id="placementsFour" name="" placeholder="No. Of Recruitments"-->
  <!--                                 class="info-input"/>-->
  <!--                        </div>-->
  <!--                        <div class="col-md-3">-->
  <!--                          <input type="text" id="packageFour" name="" placeholder="Package Offered" class="info-input"/>-->
  <!--                        </div>-->
  <!--                      </div>-->
  <!--                      <div class="row">-->
  <!--                        <div class="col-md-12 text-center">-->
  <!--                          <button type="button" class="addMoretr" @click="addMoreRec($event)"><i-->
  <!--                              class="fas fa-plus-circle"></i> Add More-->
  <!--                          </button>-->
  <!--                        </div>-->
  <!--                      </div>-->
  <!--                    </li>-->
  <!--                    <li>-->
  <!--                      <div class="row">-->
  <!--                        <div class="col-md-12 text-center">-->
  <!--                          2019 - 2020-->
  <!--                        </div>-->
  <!--                      </div>-->
  <!--                    </li>-->
  <!--                    <li>-->
  <!--                      <div class="row rowFlex mtb15">-->
  <!--                        <div class="col-md-3 border-right text-center">-->
  <!--                          <div class="topRecLogo">-->
  <!--                                                        <span class="logoshow">-->
  <!--                                                            <p>Add <br>Logo</p>-->
  <!--                                                         </span>-->
  <!--                            <input type="file" id="uploadRacLogo2020" class="uploadCollegeImg uploadImgs facultyImg"-->
  <!--                                   @change="changeRacLogo($event)"/>-->
  <!--                            <label for="uploadRacLogo2020">-->
  <!--                              <div class="editIcon">-->
  <!--                                <i class="fas fa-pencil-alt"></i>-->
  <!--                              </div>-->
  <!--                            </label>-->
  <!--                          </div>-->
  <!--                        </div>-->
  <!--                        <div class="col-md-3 border-right">-->
  <!--                          <input type="text" id="TopRecFive" name="" placeholder="Recruiter" class="info-input"/>-->
  <!--                        </div>-->
  <!--                        <div class="col-md-3 border-right">-->
  <!--                          <input type="text" id="placementsFive" name="" placeholder="No. Of Recruitments"-->
  <!--                                 class="info-input"/>-->
  <!--                        </div>-->
  <!--                        <div class="col-md-3">-->
  <!--                          <input type="text" id="packageFive" name="" placeholder="Package Offered" class="info-input"/>-->
  <!--                        </div>-->
  <!--                      </div>-->
  <!--                      <div class="row">-->
  <!--                        <div class="col-md-12 text-center">-->
  <!--                          <button type="button" class="addMoretr" @click="addMoreRec($event)"><i-->
  <!--                              class="fas fa-plus-circle"></i> Add More-->
  <!--                          </button>-->
  <!--                        </div>-->
  <!--                      </div>-->
  <!--                    </li>-->
  <!--                  </ul>-->
  <!--                </div>-->
  <!--              </form>-->
  <!--            </div>-->
  <!--          </div>-->
  </div>

</div>
</template>

<script>
import axios from "axios";
import {requestHeaders} from "../../_helpers/apiHelper";

export default {
  name: "Placements",
  data(){
    return{
      placementHighlight: [],
      coursePlacements: [],
      updateCoursePlacement: null,
    }
  },
  mounted() {
    this.getPlacementHighlights();
    this.getCoursePlacements();
  },
  methods:{
    getPlacementHighlights(){
      let self = this;
      axios.post(`${this.$parent.url}api/v2/college-profile/show-placement-highlights`, {}, {headers:requestHeaders()}).then(
          function (response){
            if(response['data']['response']['status'] == 200){
              self.placementHighlight = response['data']['response']['highlights'];
            }
          }
      )
    },
    getCoursePlacements(){
      let self = this;
      axios.post(`${this.$parent.url}api/v2/college-profile/show-course-recruitments`, {}, {headers:requestHeaders()}).then(
          function (response){
            if(response['data']['response']['status'] == 200){
              self.coursePlacements = response['data']['response']['recruitments']
            }
          }
      )
    },
    filterCoursePlacement(){
      let self = this;
      let couserId = event.currentTarget.getAttribute('data-id');
      let placementCourse = self.coursePlacements.filter(
          course => course.assigned_course_enc_id ==  couserId
      )
      self.updateCoursePlacement = placementCourse[0];
    },
    updateCoursePlacementStats(){
      let self = this;
      let coursePlacementForm = document.querySelector('#coursePlacement');
      let data = self.$parent.createDataObject(coursePlacementForm);
      data.append('recruitment_id', event.currentTarget.getAttribute('data-id'));
      self.$parent.notchLoading = 'coursePlacement';
      axios.post(`${this.$parent.url}api/v2/college-profile/update-course-recruitment`, data, {headers:requestHeaders()}).then(
          function (response){
            if(response['data']['response']['status'] == 200){
              self.getCoursePlacements();
              self.$parent.notchLoading = '';
              self.updateCoursePlacement = null;
              self.$parent.emptyFormFields(coursePlacementForm);
            }else{
              self.updateCoursePlacement = null;
            }
          }
      )
    },
    addCoursePlacement(){
      let self = this;
      let coursePlacementForm = document.querySelector('#coursePlacement');
      let data = self.$parent.createDataObject(coursePlacementForm);
      let hasError = coursePlacementForm.querySelector('.hasError');
      if (hasError) {
        return false;
      }
      self.$parent.notchLoading = 'coursePlacement';
      axios.post(`${this.$parent.url}api/v2/college-profile/add-course-recruitment`, data, {headers:requestHeaders()}).then(
          function (response){
            if(response['data']['response']['status'] == 200){
              self.$parent.emptyFormFields(coursePlacementForm);
              self.$parent.notchLoading = null;
              self.getCoursePlacements();
            }else{
              self.$parent.notchLoading = null;
            }
          }
      )
    },
    savePlacementHighlights(){
      let self = this;
      let placementHighlights = document.querySelector('#placementHighlights');
      let data = self.$parent.createDataObject(placementHighlights);
      self.$parent.notchLoading = 'placementHighlights';
      axios.post(`${this.$parent.url}api/v2/college-profile/add-placement-highlights`, data, {headers:requestHeaders()}).then(
          function (response){
            if(response['data']['response']['status'] == 200){
              self.$parent.emptyFormFields(placementHighlights);
              self.getPlacementHighlights()
              self.$parent.notchLoading = null;
            }else {
              self.$parent.notchLoading = null;
            }
          }
      )
    },
    removeCoursePlacement(){
      let self = this;
      let data = {recruitment_id: event.currentTarget.getAttribute('data-id')}
      axios.post(`${this.$parent.url}api/v2/college-profile/remove-course-recruitment`, data, {headers: requestHeaders()}).then(
          function (response){
            if(response['data']['response']['status'] == 200){
              self.getCoursePlacements();
            }
          }
      )
    },
  },
}
</script>

<style scoped>

</style>